<template lang="html">
    <div class="row">
        <div class="small-12 large-9 column">
            <Overlay></Overlay>
        </div>
    </div>
</template>

<script>
    import {ProduktRESTHelper} from "./classes/api.js";
    import Overlay from "./components/PrintQ3DOverlay.vue";

    export default {
        components: { Overlay },
        props: ['message'],
        provide() {
            return {
                globalConfig: window.FlyerlineConfig
            }
        },
        methods: {

        },
        mounted () {
            console.log( this.message )
        }
    };
</script>